module.exports = __webpack_public_path__ + "static/media/logo_pdf.120f894e.png";